<template>
  <div id="pageRoot">
    <img src="/pages/img/album/assets_p2/titulo.svg" style="width: 650px; margin-left: 200px; margin-top: 60px; position: absolute; z-index: 1" />

    <img src="/pages/img/album/assets_p2/A.svg" style="position: absolute; height: 65px; left: 60px; top: 307px;" class="basicItem02" />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      defaultText="Araña"
      disabled
      id="inputField01"
    />

    <img src="/pages/img/album/assets_p2/B.svg" style="position: absolute; height: 65px; left: 60px; top: 407px;" class="basicItem01" />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />

    <img src="/pages/img/album/assets_p2/C.svg" style="position: absolute; height: 65px; left: 60px; top: 507px;" class="basicItem02" />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
    />

    <img src="/pages/img/album/assets_p2/D.svg" style="position: absolute; height: 65px; left: 60px; top: 607px;" class="basicItem02" />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="4"
      id="inputField04"
    />

    <img src="/pages/img/album/assets_p2/E.svg" style="position: absolute; height: 65px; left: 560px; top: 307px;" class="basicItem01" />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="5"
      id="inputField05"
    />

    <img src="/pages/img/album/assets_p2/F.svg" style="position: absolute; height: 65px; left: 560px; top: 407px;" class="basicItem02" />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="6"
      id="inputField06"
    />

    <img src="/pages/img/album/assets_p2/G.svg" style="position: absolute; height: 65px; left: 560px; top: 507px;" class="basicItem01" />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="7"
      id="inputField07"
    />

    <img src="/pages/img/album/assets_p2/H.svg" style="position: absolute; height: 65px; left: 560px; top: 607px;" class="basicItem02" />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="8"
      id="inputField08"
    />
  </div>
</template>
<style scoped>
#inputField01 {
  position: absolute;
  width: 310px;
  left: 120px;
  top: 307px;
}
#inputField02 {
  position: absolute;
  width: 310px;
  left: 120px;
  top: 407px;
}
#inputField03 {
  position: absolute;
  width: 310px;
  left: 120px;
  top: 507px;
}
#inputField04 {
  position: absolute;
  width: 310px;
  left: 120px;
  top: 607px;
}
#inputField05 {
  position: absolute;
  width: 310px;
  left: 620px;
  top: 305px;
}
#inputField06 {
  position: absolute;
  width: 310px;
  left: 620px;
  top: 407px;
}
#inputField07 {
  position: absolute;
  width: 310px;
  left: 620px;
  top: 507px;
}
#inputField08 {
  position: absolute;
  width: 310px;
  left: 620px;
  top: 615px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["alb/Video 3b.mp4"],
    }
  }
}
</script>